module.exports = __webpack_public_path__ + "static/img/registerSuccess.70d5cc35.png";